'use client';

import { memo } from 'react';
import type { FC } from 'react';
import { CaseCardBase } from './CaseCardBase';
import { Credits } from '../Credits';
import { BonusCredits } from '../BonusCredits';
import { OverlayBadge } from '../ui';
import { formatCreditsShort } from '../../utils/formatters';
import { GiOpenChest } from '../icons';

interface CaseCardProps {
  id: string;
  name: string;
  imageUrl: string;
  imagePlaceholder?: string | null;
  priceInCredits?: number;
  openingsCount?: number;
  isNew?: boolean;
  /** SHOT BAND case — price is in club bonus coins, so it renders with the magenta bolt
   *  instead of the gold coin of the main balance. */
  bonusCurrency?: boolean;
  onClick?: (id: string) => void;
}

const CaseCardComponent: FC<CaseCardProps> = ({
  id,
  name,
  imageUrl,
  imagePlaceholder,
  priceInCredits,
  openingsCount,
  isNew,
  bonusCurrency = false,
  onClick,
}) => {
  const topSlot = isNew ? (
    <div className="bg-gradient-to-br from-[#ff6b6b] to-[#ee5a5a] text-white text-xs font-bold py-1 px-2 rounded">NEW!</div>
  ) : null;

  const bottomSlot = (
    <>
      <OverlayBadge>
        <span className="text-sm font-semibold text-white">{name}</span>
      </OverlayBadge>

      <div className="flex flex-row items-center gap-1.5">
        {priceInCredits !== undefined && (
          <OverlayBadge>
            {bonusCurrency ? <BonusCredits amount={priceInCredits} /> : <Credits amount={priceInCredits} />}
          </OverlayBadge>
        )}
        {openingsCount !== undefined && (
          <OverlayBadge>
            <GiOpenChest style={{ marginRight: '4px' }} />
            <span className="text-sm font-semibold text-white">{formatCreditsShort(openingsCount)}</span>
          </OverlayBadge>
        )}
      </div>
    </>
  );

  return (
    <CaseCardBase
      imageUrl={imageUrl}
      imagePlaceholder={imagePlaceholder}
      alt={name}
      onClick={() => onClick?.(id)}
      topSlot={topSlot}
      bottomSlot={bottomSlot}
    />
  );
};

export const CaseCard = memo(CaseCardComponent);
